export enum HomeUrls {
    BUSES_ALTAS_CUMBRES = 'https://www.busesaltascumbres.cl',
    BUSES_PULLMANTUR = 'https://home.busespullmantur.cl',
    BUSES_NARBUS = 'https://www.narbus.cl'
}
